<template>
    <site-layout>
        <base-message v-if="success">
            <strong>Please check your email.</strong>
            We just sent you email with password reset link.
        </base-message>

        <template v-else>
            <div align="center">
                <img src="../assets/img/logo.png" class="site-logo container" alt=""/>

                <div class="has-text-white">
                    <b>Reset password</b><br/>
                    Enter the email address you used to sign up to Teamforce <br/>
                    and we'll send you instructions to reset your password.
                </div><br/>
            </div>

            <base-backend-errors :data="reset_link.error"/>

            <base-input
                v-model="form.email"
                name="email"
                icon="fas fa-envelope"
                validate="required|email"
                placeholder="Email"/>

            <base-button
                @click="submit"
                :loading="reset_link.loading"
                class="is-success is-fullwidth"
                icon="fas fa-check"
                text="Reset my password"/>
        </template>

        <base-button
            :to="{name: 'signin'}"
            class="is-primary is-fullwidth"
            icon="fas fa-arrow-left"
            text="Go back"/>
    </site-layout>
</template>

<script>
import { mapState } from 'vuex';
import SiteLayout from '../components/layouts/SiteLayout.vue';

export default {
    name: 'RestPassword',
    components: { SiteLayout },
    data() {
        return { form: { email: null }, success: null };
    },
    computed: {
        ...mapState('reset_password', ['reset_link']),
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return;

                this.$store.dispatch('reset_password/reset_link', this.form).then(() => {
                    this.success = true;
                });
            });
        },
    },
};
</script>
